export var source = "fragment GiftRecipient on GiftCardRecipient {\n  name\n  email\n  message\n  date\n}";
export default source;